const getLiveRegionText = (quantity, isAddToCartVariant, quantityLabel, inCartLabel) => {
  if (!isAddToCartVariant) return `${quantityLabel} ${quantity}`;
  return `${quantity} ${inCartLabel}`;
};
export {
  getLiveRegionText
};
